<div class="modal-header">
   <h2 class="modal-title" data-testid="tina-search-heading-title">{{ "MC_TINA_LOCATION_SEARCH_TITLE" | translate }}</h2>
   <telenet-icon data-testid="tina-search-btn-close" class="modal-dismiss" name="close" (click)="modalRef.dismiss()"></telenet-icon>
</div>

<div class="modal-body">
   <div class="form-group row">
      <label for="tinaCountry" class="col-sm-4 col-form-label" [innerHTML]="'MC_CUSTOMERDETAILS_DETAILS_INVCOUNTRY' | translate"></label>
      <div class="col-sm-8">
         <select data-testid="tina-search-select-country" id="tinaCountry" class="form-control form-control-sm" [ngModel]="selectedCountry" (ngModelChange)="onCountryChanged($event)">
            @for (country of countries; track country) {
            <option [value]="country.code">
               <span>{{ country.description }}</span>
            </option>
            }
         </select>
      </div>
   </div>

   <div class="form-group row">
      <label class="col-sm-4 col-form-label" [innerHTML]="'MC_TINA_LOCATION_LOCATION' | translate"></label>
      <div class="col-sm-4">
         @if (useTinaLookup) {
         <my-cloud-search-autocomplete data-testid="tina-search-input-postalCode" [selectedModel]="selectedPostalCode" [searchFn]="municipalitySearchFn"
            [placeholder]="'MC_TINA_LOCATION_ZIP_CODE' | translate" [multiple]="false" [highlightSearch]="true" (selectedModelChange)="onPostalCodeSelected($event)"
            [performInitialSearchOnFocus]="false" [disabled]="!selectedCountry">
            <ng-template label-template let-item="item" let-clear="clear">
               <span>{{ item }}</span>
               <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>
            <ng-template option-template let-item="item">
               <span>{{ item }}</span>
            </ng-template>
         </my-cloud-search-autocomplete>
         }
         @if (usePlainInputs) {
         <input data-testid="tina-search-input-postalCode-manual" type="text" class="form-control form-control-sm"
            [placeholder]="'MC_TINA_LOCATION_ZIP_CODE' | translate" [(ngModel)]="selectedPostalCode" />
         }
      </div>
      <div class="col-sm-4">
         @if (useTinaLookup) {
         <select data-testid="tina-search-select-subMunicipality" class="form-control form-control-sm" [disabled]="!selectedMunicipalityResult"
            [ngModel]="selectedMunicipality" (ngModelChange)="onMunicipalitySelected($event)">
            <option [ngValue]="undefined" [disabled]="true" disabled selected>{{ 'MC_TINA_LOCATION_CITY' | translate }}</option>
            @for (sub of selectedMunicipalityResult?.subMunicipalityNames; track sub) {
               <option [value]="sub.name">{{ sub.name }}</option>
            }
         </select>
         }
         @if (usePlainInputs) {
         <input data-testid="tina-search-input-municipality-manual" type="text" class="form-control form-control-sm"
            [placeholder]="'MC_TINA_LOCATION_CITY' | translate" [(ngModel)]="selectedMunicipality" />
         }
      </div>
   </div>

   <div class="form-group row">
      <label class="col-sm-4 col-form-label" [innerHTML]="'MC_TINA_LOCATION_STREET_NAME' | translate"></label>
      <div class="col-sm-8">
         @if (useTinaLookup) {
         <my-cloud-search-autocomplete data-testid="tina-search-input-streetName" [selectedModel]="selectedStreet" [searchFn]="streetSearchFn"
            [placeholder]="'MC_TINA_LOCATION_STREET_NAME' | translate" [multiple]="false" [highlightSearch]="true" [disabled]="!selectedMunicipality"
            (selectedModelChange)="onStreetSelected($event)" [performInitialSearchOnFocus]="false">
            <ng-template label-template let-item="item" let-clear="clear">
               <span>{{ item.streetNames[0]?.name }}</span>
               <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>
            <ng-template option-template let-item="item">
               <span>{{ item.streetNames[0]?.name }}</span>
            </ng-template>
         </my-cloud-search-autocomplete>
         }
         @if (usePlainInputs) {
         <input data-testid="tina-search-input-streetName-manual" type="text" class="form-control form-control-sm"
            [placeholder]="'MC_TINA_LOCATION_STREET_NAME' | translate" [(ngModel)]="streetName" />
         }
      </div>
   </div>

   <div class="form-group row">
      <label for="searchHouseNumber" class="col-sm-4 col-form-label" [innerHTML]="'MC_TINA_LOCATION_HOUSE_NUMBER' | translate"></label>
      <div class="col-sm-8">
         <div class="row">
            <div class="col-sm-6">
               <input data-testid="tina-search-input-houseNumber" type="text" class="form-control form-control-sm" id="searchHouseNumber" name="searchHouseNumber"
                  [placeholder]="'MC_TINA_LOCATION_HOUSE_NUMBER' | translate" [ngModel]="houseNumberInput" (ngModelChange)="onHouseNumberChanged($event)"
                  [disabled]="!tinaUnavailable && !streetName" />
            </div>
            <div class="col-sm-6">
               <input data-testid="tina-search-input-boxNumber" type="text" class="form-control form-control-sm" id="searchBoxNumber" name="searchBoxNumber"
                  [placeholder]="'MC_TINA_LOCATION_BOX_NUMBER' | translate" [ngModel]="boxNumber" (ngModelChange)="onBoxNumberChanged($event)" [disabled]="!tinaUnavailable && !streetName" />
            </div>
         </div>
      </div>
   </div>

   @if (errorMessage) {
   <div class="mt-3 alert alert-danger" data-testid="tina-search-error">
      {{ errorMessage | translate }}
   </div>
   }

   @if (!tinaUnavailable && filteredAddressResults.length > 0) {
   <div class="mt-2">
      <table class="table table-sm table-hover" data-testid="tina-search-results-table">
         <thead>
            <tr>
               <th>{{ "MC_TINA_LOCATION_STREET_NAME" | translate }}</th>
               <th>{{ "MC_TINA_LOCATION_HOUSE_NUMBER" | translate }}</th>
               <th class="actions">
                  <p [innerHTML]="'MC_ACTIONS' | translate"></p>
               </th>
            </tr>
         </thead>
         <tbody>
            @for (result of filteredAddressResults; track result; let i = $index) {
            <tr class="cursor-pointer" [attr.data-testid]="'tina-search-result-row-' + i"
               (click)="selectResult(result)">
               <td>
                  <telenet-icon name="locations"></telenet-icon>
                  <span class="ml-2">{{ streetName }}</span>
               </td>
               <td>
                  <span>{{ result.houseNumber }}</span>
                  @if (result.subHouseNumber) {
                     <span>{{ result.subHouseNumber }}</span>
                  }
                  @if (result.boxNumber) {

                     <span class="ml-2">(</span>
                     @if (result.boxNumber) {
                        <telenet-icon name="email"></telenet-icon>
                     }
                     <span class="ml-1">{{ result.boxNumber }})</span>
                  
                  }
               </td>
               <td class="actions">
                  <button [attr.data-testid]="'tina-search-btn-select-' + i" class="btn btn-telenet-light ml-2" name="save" (click)="selectResult(result)">
                     <telenet-icon name="plus"></telenet-icon>
                  </button>
               </td>
            </tr>
            }
         </tbody>
      </table>
   </div>
   }
</div>

<div class="modal-footer">
   <button data-testid="tina-search-btn-cancel" type="button" class="btn" (click)="modalRef.dismiss()">
      {{ "MC_CANCEL" | translate }}
   </button>
   @if (tinaUnavailable) {
   <button data-testid="tina-search-btn-manual" type="button" class="btn btn-telenet" (click)="continueWithManualInput()"
      [disabled]="!selectedPostalCode || !streetName || !houseNumber">
      {{ "MC_TINA_LOCATION_MANUAL_INPUT" | translate }}
   </button>
   }
</div>